import * as $ from 'jquery';

import 'etc/designs/base/clientlibs/shared/libraries/SCS.Url.js';

import { Count, Service } from '../SocialMedia';

// Base url to share something on swisscom
const SHARE_URL = '/portal-app/roamingtool/public/social-media-statistics';
// Base url to query the swisscom API
const COUNT_URL = '/portal-app/roamingtool/public/social-media-statistics';

function shareCount(url : string, name : string) : Promise<Count> {
	url = SCS.Url.stripPathPrefixFromUrl(url);
	url = SCS.Url.stripProtocolFromUrl(url);

	return new Promise((resolve, reject) => {
		$.ajax({
			// Get parameters to pass
			data: {url: encodeURI(url)},
			// Filled in by jquery
			dataType: 'json',
			// Pass through
			error: reject,
			// Extract count from response
			success(res) {
				const response : Count = {
					count: 0,
				};
				if (res && res[0] && res[0].services) {
					for(const service of res[0].services) {
						if (service.service === name) {
							response.count = service.count;
							break;
						}
					}
				}

				// Call resolve
				resolve(response);
			},
			// Connection type
			type: 'GET',
			// Count url
			url: COUNT_URL,
		});
	});
}

function shareUrl(_url : string) {
	return SHARE_URL;
}

export class SCShareCount implements Service {
	public name = 'SCShareCount';
	public category = ['shareCount'];

	public shareUrl = shareUrl;
	public shareCount = shareCount;
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/generic/socialmedia/services/SCShareCount.ts